import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:4100/api",
  // baseURL: "https://or-dev.prasmul-eli.co/api",
  baseURL: "https://registration.prasmul-eli.co/api",
  // Batasi waktu tunggu agar request tidak menggantung tanpa batas
  // (mis. saat layanan eksternal di backend lambat/hang). 120 dtk memberi
  // ruang untuk proses checkout yang panjang namun tetap memutus jika hang.
  timeout: 120000,
});

// Normalisasi error timeout / tidak ada response dari server ke bentuk
// { status, errors: [...] } supaya konsisten dengan errorHandler dan pesan
// ke user tidak kosong. Penolakan promise ini juga otomatis memicu blok
// catch di handler (mis. handleCheckout) yang me-reset disabledRegistration.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ECONNABORTED" || !error.response) {
      error.status = "Koneksi Bermasalah";
      error.errors = [
        error.code === "ECONNABORTED"
          ? "Permintaan terlalu lama merespons (timeout). Silakan periksa koneksi Anda dan coba lagi"
          : "Tidak dapat terhubung ke server. Silakan periksa koneksi Anda dan coba lagi",
      ];
    }
    return Promise.reject(error);
  }
);

export default instance;
